import { Component, EventEmitter, OnInit, Input, Output } from '@angular/core';
import { GlobalConstants } from 'src/app/pages/common/global-variables';
import { ApiService } from 'src/app/pages/common/api.service';
import { ToastrService } from 'ngx-toastr';
import { UntypedFormBuilder, FormGroup, FormControl, Validators } from '@angular/forms';

@Component({
  selector: 'app-confirm-email-modal',
  templateUrl: './confirm-email-modal.component.html',
  styleUrls: ['./confirm-email-modal.component.scss'],
  providers: [ApiService, GlobalConstants]
})
export class ConfirmEmaiModalComponent implements OnInit {
  isLoading = false;
  @Input() existingEmail: string;
  // @Input() existingEmail: string;
  @Output() hideEvent: EventEmitter<boolean> = new EventEmitter();

  formSubmited = false;
  emailPattern = /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/;
  createWithUserForm: any = this.fb.group({
    email: ['', [Validators.required, Validators.email, Validators.pattern(this.emailPattern)]]
  });
  get f() { return this.createWithUserForm.controls; }

  constructor(
    public GlobalConstants: GlobalConstants,
    private _apiService: ApiService,
    private toastr: ToastrService,
    private fb: UntypedFormBuilder
  ) { }

  ngOnInit(): void {
    console.log(this.existingEmail);
    this.createWithUserForm.patchValue({ email: this.existingEmail });
  }
  submitEmailChange(){
    if(!this.isLoading){
      this.formSubmited = true;
      if (this.createWithUserForm.valid) {
        this.isLoading = true;
        if(this.f.email.value === this.existingEmail){
          this.resendEmail();
        }
        else{
          this.updateEmail()
        }
      } else {
        this.isLoading = false;
        return false;
      }
    }
  }
  resendEmail(){
    this._apiService.resendEmail().subscribe((res: any) => {
      if(res){
        if(res.resp == true){
          this.toastr.success($localize`Email sent. Please click on the verification link sent to your email!`,'', {
            timeOut: 6000,
          });
        }
        else if(res.resp == 'too_many'){
          this.toastr.warning($localize`Limit exceeded. Please try after sometime!`,'', {
            timeOut: 6000,
          });
        }
        this.hideModal();
      }
      else{
        this.showToast($localize`Something went wrong!`,3000)
      }
        this.isLoading = false;
      },
      (err) => {
        this.isLoading = false;
        this.showToast($localize`Something went wrong!`,3000)
      }
    );
  }
  updateEmail(){
    this._apiService.updateUserCreds({email: this.f.email.value}).subscribe((res: any) => {
      this.toastr.success($localize`Email updated. Please click on the verification link sent to your email!`,'', {
        timeOut: 6000,
      });
      this.isLoading = false;
      setTimeout(()=>{
        this.hideModal();
      }, 500)

    },
    (err) => {
      this.showToast($localize`Something went wrong!`,3000)
      }
    );
  }
  showToast(msg,secs){
    this.toastr.error(msg,'', {
      timeOut: secs,
    });
  }
  hideModal() {
    if (window.innerWidth < 768) {
      this.hideEvent.emit(true);
    }
    else{
      this.hideEvent.emit(true);
    }

  }
}
